import BLOG from "../../public/blog.json";
import type { Lang } from "@/i18n";

/** Un articol, în forma în care îl scrie scripts/blog.mjs.
 *
 *  Fișierul e generat din Markdown la build. Clientul îl importă prin Vite,
 *  serverul îl citește din WEB_DIST pentru meta și JSON-LD, iar prerandarea își
 *  ia rutele din el — trei consumatori care nu pot împărți un import, de aceea
 *  e JSON și nu un modul. Aceeași soluție ca la public/faq.json. */
export interface BlogLang {
  /** Titlul pentru <title> și pentru rezultatele de căutare, ținut sub limita
   *  de afișare. */
  title: string;
  /** Titlul din pagină. Egal cu `title` la aproape toate articolele; diferă
   *  acolo unde formularea bună depășește ce încape într-un rezultat. */
  h1: string;
  summary: string;
  html: string;
  toc: Array<{ id: string; text: string; level: number }>;
  words: number;
  minutes: number;
}

export interface BlogPost {
  slug: string;
  published: string;
  updated: string;
  /** „tech" primește TechArticle în structured data, restul BlogPosting. */
  kind: "tech" | "post";
  /** Slugul serviciului de care ține articolul. Legătura internă e jumătate
   *  din valoarea unui blog: articolul trimite la serviciu, serviciul rămâne
   *  ținta comercială. */
  service: string;
  /** Slugul cazului care ilustrează articolul, dacă există. */
  case?: string;
  /** Departajator la egalitate de dată de publicare. Mai mic, mai sus. */
  order?: number;
  langs: Record<string, BlogLang>;
}

export const POSTS = (BLOG.posts as BlogPost[]);

/** Bucățile de adresă, în ordinea de publicare. Aceeași poveste ca la
 *  caseSlugs: prerandarea are propriul arbore de rute, iar o listă scrisă a
 *  doua oară ar devia. Aici lista vine din conținut, deci nu are cum. */
export const BLOG_SLUGS: readonly string[] = POSTS.map((p) => p.slug);

export function postBySlug(slug: string): BlogPost | undefined {
  return POSTS.find((p) => p.slug === slug);
}

/** Textul articolului în limba cerută, cu engleza ca plasă de siguranță.
 *  Plasa nu ar trebui să se folosească niciodată — compilatorul cade dacă
 *  lipsește o limbă — dar tipul o cere, iar o pagină goală ar fi mai rea. */
export function postText(p: BlogPost, lang: Lang): BlogLang {
  return p.langs[lang] ?? p.langs.en;
}
